/* @ngInject */
const metadata = (
  areaButtons,
  areaFields
) => {
  const self = {}

  self.favoriteSort = ['name',]

  self.buttons = [
    areaButtons.search,
    areaButtons.edit,
    areaButtons.delete,
  ]

  self.fields = areaFields

  return self
}

export default metadata



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/rails/area/services/metadata.service.js